import { render } from "./RecordExpensesModal.vue?vue&type=template&id=26d6bef2"
import script from "./RecordExpensesModal.vue?vue&type=script&lang=js"
export * from "./RecordExpensesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__